import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBug, faExclamationCircle, faTicketAlt, faEyeSlash } from "@fortawesome/pro-solid-svg-icons";
export const ActionsDropdown = ({ isOpen, dropdownOpenId, dropdownPosition, onActionClick, onClose, }) => {
    if (!isOpen || !dropdownOpenId || !dropdownPosition) {
        return null;
    }
    const actions = [
        {
            action: "Create Defect",
            icon: faBug,
            color: "#dc3545",
            bgColor: "#fff5f5",
        },
        {
            action: "Create Incident",
            icon: faExclamationCircle,
            color: "#fd7e14",
            bgColor: "#fff8f0",
        },
        {
            action: "Create Zendesk Ticket",
            icon: faTicketAlt,
            color: "#6f42c1",
            bgColor: "#f8f5ff",
        },
        {
            action: "Ignore",
            icon: faEyeSlash,
            color: "#6c757d",
            bgColor: "#f8f9fa",
        },
    ];
    return (_jsx("div", { style: {
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 1500,
            pointerEvents: "none",
        }, onClick: onClose, children: _jsx("div", { className: "network-errors-dropdown-portal", style: {
                top: `${dropdownPosition.top}px`,
                left: `${dropdownPosition.left}px`,
                pointerEvents: "auto",
            }, "data-dropdown-portal": true, children: _jsx("div", { className: "network-errors-dropdown-content", children: actions.map(({ action, icon, color, bgColor }) => (_jsxs("button", { onClick: (e) => {
                        e.stopPropagation();
                        onActionClick(action);
                    }, className: "network-errors-dropdown-item", onMouseEnter: (e) => {
                        e.currentTarget.style.backgroundColor = bgColor;
                        e.currentTarget.style.color = color;
                    }, onMouseLeave: (e) => {
                        e.currentTarget.style.backgroundColor = "transparent";
                        e.currentTarget.style.color = "#495057";
                    }, children: [_jsx(FontAwesomeIcon, { icon: icon, className: "network-errors-dropdown-icon" }), _jsx("span", { children: action })] }, action))) }) }) }));
};
//# sourceMappingURL=ActionsDropdown.js.map